import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as BSL_Common from "../components/BSL_CommonControls";
import BSL_TextInput from "../components/BSL_TextInput";
import { Chip, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import BSL_ColourSelector from "../components/BSL_ColourSelector";
import ColourChip from "../components/ColourChip";

const useStyles = makeStyles({
    root: {
        overflow: "auto",
        height: "90%",
    },
    colour_array_row: {
        display: "flex",
        margin: "3px 0px",
        padding: "3px 0px",
        borderBottom: "1px dotted grey",
    },
    colour_array_row_header: {
        display: "flex",
        minWidth: "300px",
    },
    colour_array_row_content: {
        display: "flex",
        flexWrap: "wrap",
        flex: "1",
    },
    colour_row_content: {
        display: "flex",
        flexDirectio: "column",
        flex: "1",
    },
    label: { flex: "none", padding: "0px", margin: "1px" },
});

export default function ManageColours(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    const config = useSelector((state) => state.config);
    window.config = config;
    let input_style = { padding: "0px", margin: "1px" };
    let list_input_style = { padding: "0px", margin: "1px", width: "80%" };

    const handleDelete = (chipToDelete) => () => {
        // setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };

    let colour_rows = [];
    let valid_colours = [];

    for (let colour_key in config.colour_map) {
        // let colous_csv = "";
        // for (let colour of config.colour_arrays[colour_array_key]) {
        //     colous_csv += (colous_csv !== "" ? ", " : "") + colour;
        // }
        valid_colours.push(colour_key);
        colour_rows.push(
            <div className={classes.colour_array_row}>
                <div className={classes.colour_array_row_header}>
                    <IconButton aria-label="delete" size="small" onClick={() => {}}>
                        <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    <BSL_TextInput
                        value={colour_key}
                        tight
                        style={input_style}
                        // onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                    />
                </div>
                <div className={classes.colour_row_content}>
                    <BSL_ColourSelector
                        custom_select
                        tight
                        // label="Colour"
                        // colourList={selectedInfillFront?.colours}
                        value={config.colour_map[colour_key].Col1}
                        style={{ flex: "none", width: "160px", padding: "0px", margin: "1px" }}
                        // onClose={(colour) => dispatch(updateSiteParameters("ExistingStructure.RoofColour", colour))}
                    />
                    <BSL_ColourSelector
                        custom_select
                        tight
                        // label="Colour"
                        // colourList={selectedInfillFront?.colours}
                        value={config.colour_map[colour_key].Col2}
                        style={{ flex: "none", width: "160px", padding: "0px", margin: "1px" }}
                        // onClose={(colour) => dispatch(updateSiteParameters("ExistingStructure.RoofColour", colour))}
                    />
                    <BSL_ColourSelector
                        custom_select
                        tight
                        // label="Colour"
                        // colourList={selectedInfillFront?.colours}
                        value={config.colour_map[colour_key].Contrast}
                        style={{ flex: "none", width: "160px", padding: "0px", margin: "1px" }}
                        // onClose={(colour) => dispatch(updateSiteParameters("ExistingStructure.RoofColour", colour))}
                    />

                    <BSL_TextInput
                        value={config.colour_map[colour_key].Opacity}
                        min={0}
                        max={1}
                        tight
                        style={{ flex: "none", width: "80px", padding: "0px", margin: "1px" }}
                        // onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                    />
                    <BSL_TextInput
                        value={config.colour_map[colour_key].Code}
                        tight
                        style={{ flex: "none", minWidth: "80px", maxWidth: "80px", padding: "0px", margin: "1px" }}
                        // onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                    />
                </div>
            </div>
        );
    }

    let colour_array_rows = [];

    for (let colour_array_key in config.colour_arrays) {
        let colours_chips = [];
        for (let colour of config.colour_arrays[colour_array_key]) {
            colours_chips.push(
                <Chip
                    style={{ background: "#00000000" }}
                    label={
                        <>
                            <ColourChip
                                className="colour-chip"
                                colour={colour}
                                width="1rem"
                                style={{ background: "#00000000" }}
                            />
                            {colour}
                        </>
                    }
                    onDelete={handleDelete(colour)}
                />
            );
        }
        console.log("colours_chips", colours_chips);
        colour_array_rows.push(
            <div className={classes.colour_array_row}>
                <div className={classes.colour_array_row_header}>
                    <IconButton aria-label="delete" size="small" onClick={() => {}}>
                        <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    <BSL_TextInput
                        value={colour_array_key}
                        tight
                        style={input_style}
                        onClick={(e) => {
                            alert(
                                "warning: changing the name of an existing colour list is not recommeneded and may cause any linked product list or offering item to lose their colour references."
                            );
                        }}
                        // onBlur={(val) => updateMarkup(key, "DisplayName", val)}
                    />
                </div>
                <div className={classes.colour_array_row_content}>
                    {colours_chips}
                    <BSL_ColourSelector
                        value=""
                        placeholder="Add New..."
                        tight
                        colourList={valid_colours}
                        style={{ flex: "none", width: "160px", padding: "0px", margin: "1px" }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={classes.root}>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>Manage Colour Lists</BSL_Common.SectionHeader>
                {colour_array_rows}

                <div
                    className={classes.colour_array_row_header}
                    style={{
                        marginLeft: "24px",
                        maxWidth: "270px",
                    }}
                >
                    <BSL_TextInput
                        placeholder="new colour list"
                        // value={""}
                        tight
                        style={input_style}
                        // onBlur={(val) => addMarkup(val)}
                    />
                </div>
            </BSL_Common.SectionContainer>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionHeader>Manage Colours</BSL_Common.SectionHeader>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "310px" }}></div>
                    <div style={{ width: "160px" }}>Main Colour</div>
                    <div style={{ width: "160px" }}>Secondary Colour</div>
                    <div style={{ width: "160px" }}>Contrast Colour</div>
                    <div style={{ width: "80px" }}>Opacity</div>
                    <div style={{ width: "80px" }}>Code</div>
                </div>
                {colour_rows}

                <div
                    className={classes.colour_array_row_header}
                    style={{
                        marginLeft: "24px",
                        maxWidth: "270px",
                    }}
                >
                    <BSL_TextInput
                        placeholder="add new colour"
                        // value={""}
                        tight
                        style={input_style}
                        // onBlur={(val) => addMarkup(val)}
                    />
                </div>
            </BSL_Common.SectionContainer>
        </div>
    );
}
